module.exports = __webpack_public_path__ + "static/media/createnew.3b81d79e.svg";